import React from 'react';
// import { createRoot } from 'react-dom/client'
import App from './App';
import { store } from './Store/store';
import { Provider } from 'react-redux';
import { IntlProvider } from 'react-redux-multilingual';
// import { IntlReducer as Intl, IntlProvider } from 'react-redux-multilingual'
import translations from './Translations/Translations';
import './index.css';
import './App.css';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import ReactDOM from "react-dom/client";
import ReactGA from "react-ga4";

const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);

//************ */ production
// ReactGA.initialize("G-6QVF7Q4HBM");
// ReactGA.send({ hitType: "pageview", page: window.location.pathname });
// ReactGA.initialize("G-6QVF7Q4HBM", { debug_mode: true });

//************ */ staging
const Confdata = window['runConfig'];
const googleAnaId = Confdata.GA_MEASUREMENT_ID;
// ReactGA.initialize(googleAnaId);
ReactGA.initialize(googleAnaId, { debug_mode: true });
ReactGA.send({ hitType: "pageview", page: window.location.pathname });

console.log(Confdata.GA_MEASUREMENT_ID, "cofdata")

const { palette } = createTheme();

const theme = createTheme({
    typography: {
        fontFamily: 'Quicksand-Regular',
        textTransform: 'capitalize',
        lineHeight: '1.6',
        letterSpacing:"0.0625rem",
        wordBreak: "break-word",
        color: '#4d4e4e',
        display: 'block',
        margin: '0.3125rem 0.3125rem 0.3125rem 0.3125rem',

        LargeHeading: {
            fontFamily: 'Josefin Sans SemiBold',
            fontSize: '20px',
            lineHeight: '1.6',
            // letterSpacing:"0.0625rem",
            color: '#4d4e4e',
            margin: '0.3125rem 0.3125rem 0.3125rem 0.3125rem',
            display: 'block',
        },
        heading: {
            fontFamily: 'Josefin Sans SemiBold',
            fontSize: '1.25rem',
            lineHeight: '1.6',
            color: '#4d4e4e',
            margin: '0.3125rem 0.3125rem 0.3125rem 0.3125rem',
            display: 'block',
          
        },
        subHeading: {
            fontFamily: 'Josefin Sans SemiBold',
            fontSize: '16px',
            lineHeight: '1.6',
            // letterSpacing:"0.0625rem",
            color: '#4d4e4e',
            display: 'block',
            margin: '0.3125rem 0.3125rem 0.3125rem 0.3125rem',
            display: 'block',


        },
        medium: {
            fontFamily: 'Quicksand-Regular',
            fontSize: '1rem',
            color: '#4d4e4e',
            lineHeight: '1.6',
            letterSpacing: "0.0625rem",
            fontWeight: 700,
            display: 'block',
            margin: '0.3125rem 0.3125rem 0.3125rem 0.3125rem',
    
        },
        normal: {
            fontFamily: 'Quicksand-Mediums',
            fontSize: '0.875rem',
            lineHeight: '1.6',
            letterSpacing: "0.0625rem",
            color: '#4d4e4e',
            display: 'block',
            margin: '0.3125rem 0.3125rem 0.3125rem 0.3125rem',

        },
        footer:{
            fontFamily: 'Quicksand-Mediums',
            color: '#4d4e4e',
            fontSize:"0.75rem",
            lineHeight: '1.6',
            letterSpacing:  "0.0625rem",
        },
        small: {
            fontFamily: 'Quicksand-Mediums',
            fontSize: '0.75rem',
            color: '#4d4e4e',
            display: 'block',
            lineHeight: '1.6',
            letterSpacing: "0.0625rem",
            margin: '0.3125rem 0.3125rem 0.3125rem 0.3125rem',
    
        },

    },

    palette: {
        text:{
           primary:'#4d4e4e',
           secondary:"#4d4e4e",
           disabled:"#4d4e4e",
           hint:"#4d4e4e"
        },
        typography:{
            body1:'#4d4e4e'
        },
       
        secondary: {
          main: '#fcb728',
        },
        thirdcolor:{
          main:"#fee2a5a"
        },
        primary:{
          main:"#256EFF"
        },
        fifthcolor:{
          main:"#58595b"
        }
    },
    components: {
        MuiButton: {

            variants: [
                {
                    props: { variant: 'customPrimary' },
                    style: {
                        fontFamily: "Josefin Sans SemiBold",
                        boxShadow: 'none',
                        textTransform: 'none',
                        padding: '0.3125rem 0.8125rem',
                        borderRadius: '1.25rem',
                        variant: "contained",
                        lineHeight: 1.5,
                        margin: '0.625rem 0.625rem 0.625rem 0.625rem',
                        minWidth: "4rem",
                        background: '#256EFF',
                        fontSize: "1rem",
                        color: "white",
                        maxHeight:"2.125rem",
                        '&:hover': {
                            boxShadow: 'none', background: '#256EFF',
                        },
                        '&:active': {
                            boxShadow: 'none',
                        },
                        '&:focus': {
                            boxShadow: '0 0 0 0.2rem rgba(0,123,255,.5)',
                        },
                        backgroundColor: "#256EFF"
                    },
                },
                {
                    props: { variant: 'customSecondary' },
                    style: {
                        fontFamily: 'Josefin Sans SemiBold',
                        fontSize: "1rem",
                        width: '16.25rem',
                        margin: '0.625rem 0.625rem 0.625rem 0.625rem',
                        textTransform: 'unset',
                        variant: "contained",
                        color: "white",
                        background: '#256EFF',
                        minWidth: "4rem",               
                         maxHeight:"3.3rem",
                        '&:hover': {
                            boxShadow: 'none', background: '#256EFF',
                        },
                       
                    },
                },
            ],
        },
    },

})


root.render(
    <ThemeProvider theme={theme}>
      <Provider store={store}>
        <IntlProvider translations={translations}>
          <App tab="home" />
        </IntlProvider>
      </Provider>
    </ThemeProvider>
  );